import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        getInfo() {
            let param = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: this.id
            }
            $http.get('api/Order/GetReturnOrderById', param).then(res => {
                util.doResult(this, res, () => {
                    let {
                        Data
                    } = res.data;
                    this.OrderData = Data;
                    let $obj = this.OrderData.ReturnProductInitList;
                    this.totalNum1 = 0;
                    this.totalNum2 = 0;
                    this.num2 = [];
                    for (let i = 0; i < $obj.length; i++) {
                        $obj[i].ReturnPro = $obj[i].ReturnProName + '*' + $obj[i].ReturnNum
                        $obj[i].ChangePro = $obj[i].ChangeProName + '*' + $obj[i].ReturnNum
                        // $obj[i].num2=$obj[i].ReturnNum//实际退换货数量
                        //this.num2.push($obj[i].ReturnNum)

                    }
                    for (let j = 0; j < this.OrderData.ActualProductList.length; j++) {
                        if (this.OrderData.ActualProductList[j]) {
                            this.OrderData.ReturnProductNewList[j].num = this.OrderData.ActualProductList[j].ActualNum
                            //this.OrderData.ActualProductList[j].maxNum = this.OrderData.ActualProductList[j].ActualNum
                            if (this.OrderData.ActualProductList[j].Type == 0) {
                                this.totalNum1 += this.OrderData.ActualProductList[j].ActualNum
                            } else {
                                this.totalNum2 += this.OrderData.ActualProductList[j].ActualNum
                            }
                        }
                    }
                    if (this.OrderData.ReturnPic !== null) {
                        this.changePic = this.OrderData.ReturnPic.split(',');
                    }
                    this.changeProductList = cloneDeep(this.OrderData.ReturnProductNewList)
                });
            });
        },
        //获取资源包
        getReturnConfig(obj) {
            let param = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: this.id
            };
            $http.get('api/Order/GetReurnConfig', param).then(res => {
                util.doResult(this, res, () => {
                    this.returnConfigList = [];
                    let data2 = null;
                    for (var i = 0; i < res.data.Data.length; i++) {
                        if (res.data.Data[i].Id > 0) {
                            this.returnConfigList.push(res.data.Data[i])
                        }

                    }
                    if (this.returnConfigList.length > 0) {
                        for (var i = 0; i < this.returnConfigList.length; i++) {
                            for (var j = 0; j < this.returnConfigList[i].List.length; j++) {
                                if (this.returnConfigList[i].List[j].ProId == obj.ChangeProId) {
                                    this.returnConfigList[i].List[j].active = true;
                                    this.activeName = this.returnConfigList[i].Id + '';
                                }
                            }
                        }
                    }
                    this.dialogTabsVisible = true;
                });
            });
        },
        //确认换货
        ReturnOrderConfirm(param) {
            $http.post('api/Order/ReturnOrderTwoConfirm', param).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '成功确认！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.visible = false
                    this.$emit('reLoadData');
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/Exchange/components/exchangeConfirm/services.js